import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getDaysSinceStartSale,
  getIsCatalogOrUniversePagePath,
  getIsCurrentProductOutOfStock,
  getFilteredProductsInParentScope,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getNbProductsOutOfStock,
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getProductSourceKey,
  getProductTitle,
  getProductsInParentScope,
  getSaleStartTime,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { getViewedProductsData } from './viewProductPage'
import { disableMixPanelTracking } from '../disable'

export const getRelativeMPProps = (state) => {
  const nbProducts = getProductsInParentScope(state).length
  const nbProductsOutOfStock = getNbProductsOutOfStock(state)

  if (getIsCatalogOrUniversePagePath(state)) {
    return ({
      '# of Products Out of Stock': nbProductsOutOfStock,
      '# of References': getFilteredProductsInParentScope(state).length,
      'Out of Stock products': (nbProducts === nbProductsOutOfStock),
      'Page Name': 'Catalogue Page'
    })
  }

  return ({
    'Lowest Product Price': getProductCallPrice(state),
    'Page Name': 'Product Page',
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state),
    'Product Price': getProductPriceValue(state),
    'Stock Status': getIsCurrentProductOutOfStock(state) ? 'Not Available' : 'Available'
  })
}

export const mapStateToMPEvent = (
  state,
  action // state: State, action: ProductCardSlideshowNavigationAction
) => {
  const { activeSlideIndex, totalSlidesCount } = action.payload

  return {
    '# of Content in slideshow': totalSlidesCount,
    '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
    '# of Universes': getNormalizedNbUniversesInCatalog(state),
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Operation Code': getOperationCode(state),
    'Position in slideshow': activeSlideIndex,
    'Sale Start Time': getSaleStartTime(state),
    'Under Universe': getSubUniverseName(state),
    'Universe': getUniverseName(state),
    ...getRelativeMPProps(state),
    ...getViewedProductsData(state)
  }
}

const navigateProductSlideshowEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.product.PRODUCT_SLIDESHOW_NAVIGATION),
  tap(action => {
    const eventName = 'Use Travel Slideshow'
    track(eventName, mapStateToMPEvent(state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default navigateProductSlideshowEpic
